export const rond = (number, zarib = 1) => {
  number = number * 1;
  number = Math.round((number / 1000) * zarib) * 1000 * zarib;
  return number;
};
